import React, { useState, useEffect, useContext } from 'react';
import { Modal } from 'react-bootstrap';
import toast, { Toaster } from 'react-hot-toast';

import { DataContext } from '../../../init/getData';
import { Switch } from 'antd';
import Select from 'react-select';

import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { exportedVisibleTabs } from '../../../devTab/devRole/crud/pagesPermission';

const PagesPermission = (props) => {

  const { api, userData } = useContext(DataContext);
  const userId = userData.id;
  const userName = userData.name;
  const userRole = userData.role.name;

  const { showModal, toggleModal, refreshTable, tittle, idRow } = props;

  const { wareHouseData } = useContext(DataContext);


  const [settings, setSettings] = useState({});
  const [loadingEffect, setLoadingEffect] = useState(false);


  useEffect(() => {

    if (idRow) {
      setSettings(
        {
          salesDashboardPage: idRow.salesDashboardPage,

          //Accounts pages
          accountsPage: idRow.accountsPage,
          chartOfAccountPage: idRow.chartOfAccountPage,
          myAccountsPage: idRow.myAccountsPage,
          groupsPage: idRow.groupsPage,
          deliveryPage: idRow.deliveryPage,

          //cashTab Pages
          cashAccountPage: idRow.cashAccountPage,
          varianceAccountPage: idRow.varianceAccountPage,
          cashTransferPage: idRow.cashTransferPage,
          paymentsPage: idRow.paymentsPage,
          receiptsPage: idRow.receiptsPage,

          //hrTab Pages
          employeePage: idRow.employeePage,
          salaryPage: idRow.salaryPage,

          // purchaseTab Pages
          supplierPage: idRow.supplierPage,
          purchaseInvoicePage: idRow.purchaseInvoicePage,
          purchaseReturnPage: idRow.purchaseReturnPage,
          purchaseOrderPage: idRow.purchaseOrderPage,

          // salesTab Pages
          customerPage: idRow.customerPage,
          salesInvoicePage: idRow.salesInvoicePage,
          salesReturnPage: idRow.salesReturnPage,
          salesOrderPage: idRow.salesOrderPage,

          // expenseTab Pages
          expenseAccountPage: idRow.expenseAccountPage,
          expenseSupplierPage: idRow.expenseSupplierPage,
          expenseInvoicePage: idRow.expenseInvoicePage,

          // stockTab Pages
          stockControlPage: idRow.stockControlPage,
          stockTransferPage: idRow.stockTransferPage,
          stockCountPage: idRow.stockCountPage,

          // inventoryTab Pages
          productsPage: idRow.productsPage,
          categoriesPage: idRow.categoriesPage,
          brandsPage: idRow.brandsPage,
          seasonsPage: idRow.seasonsPage,
          vatGroupPage: idRow.vatGroupPage,

          // reportTab Pages
          financialPage: idRow.financialPage,
          operationalPage: idRow.operationalPage,
          stockReportPage: idRow.stockReportPage,
          sessionsPage: idRow.sessionsPage,

          // toolTab Pages
          stockToolsPage: idRow.stockToolsPage,
          openingYearPage: idRow.openingYearPage,
          posToolsPage: idRow.posToolsPage,
          importPage: idRow.importPage,
          backupPage: idRow.backupPage,

          // settingTab Pages
          generalPage: idRow.generalPage,
          userPage: idRow.userPage,
          rolePage: idRow.rolePage,
          linkAccountPage: idRow.linkAccountPage,
          currencyPage: idRow.currencyPage,

          // retailTab Pages
          posPage: idRow.posPage,
          dineInPage: idRow.dineInPage,

        }
      )

    }
  }, [idRow]);



  const handleSubmit = async () => {
    setLoadingEffect(true);

    const id = idRow.id;

    let res = await api.post(`/role/editPermissions`, JSON.stringify({ id, settings }))
    if (res.data.status) {
      toast.success(res.data.message);
      refreshTable();
      toggleModal();
    }
    else {
      toast.error(res.data.message);
    }

    setLoadingEffect(false);
  }


  const handleChange = (name, value) => {
    setSettings((prev) => ({
      ...prev,
      [name]: value,
    }));
  }



  return (
    <Modal show={showModal} backdrop="static" onHide={toggleModal} fullscreen={true}>
      <Modal.Header style={{ background: "#1f2937" }} closeButton>
        <Modal.Title style={{ color: "white" }}>{idRow.name} Pages Permissions</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div >



          <div style={{ userSelect: 'none', height: 'auto', display: 'flex', flexDirection: 'row', marginBottom: '3%' }}>
            {/* Sales dashboard Tab  */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Dashboard</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>sales Dashboard</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('salesDashboardPage', e)} checked={settings.salesDashboardPage} />
              </Form.Group>

            </Form>


            {/* Accounts Tab  */}

            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Accounts</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Accounts</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('accountsPage', e)} checked={settings.accountsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>chart Of Account</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('chartOfAccountPage', e)} checked={settings.chartOfAccountPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>My Accounts</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('myAccountsPage', e)} checked={settings.myAccountsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Groups</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('groupsPage', e)} checked={settings.groupsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Delivery</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('deliveryPage', e)} checked={settings.deliveryPage} />
              </Form.Group>

            </Form>

            {/* cashTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>cash</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>cash Account</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('cashAccountPage', e)} checked={settings.cashAccountPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Variance Account</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('varianceAccountPage', e)} checked={settings.varianceAccountPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Cash Transfer</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('cashTransferPage', e)} checked={settings.cashTransferPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Payments</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('paymentsPage', e)} checked={settings.paymentsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Receipts</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('receiptsPage', e)} checked={settings.receiptsPage} />
              </Form.Group>

            </Form>

            {/* hrTab Pages  */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>HR</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Employee</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('employeePage', e)} checked={settings.employeePage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Salary</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('salaryPage', e)} checked={settings.salaryPage} />
              </Form.Group>

            </Form>

            {/* purchaseTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Purchase</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Supplier</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('supplierPage', e)} checked={settings.supplierPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Purchase Invoice</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('purchaseInvoicePage', e)} checked={settings.purchaseInvoicePage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Purchase Return</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('purchaseReturnPage', e)} checked={settings.purchaseReturnPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Purchase Order</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('purchaseOrderPage', e)} checked={settings.purchaseOrderPage} />
              </Form.Group>

            </Form>

            {/* salesTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Sales</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Customer</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('customerPage', e)} checked={settings.customerPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Sales Invoice</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('salesInvoicePage', e)} checked={settings.salesInvoicePage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Sales Return</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('salesReturnPage', e)} checked={settings.salesReturnPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Sales Order</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('salesOrderPage', e)} checked={settings.salesOrderPage} />
              </Form.Group>

            </Form>

          </div>

          <div style={{ userSelect: 'none', height: 'auto', display: 'flex', flexDirection: 'row', marginBottom: '2%' }}>
            {/* expenseTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Expense</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Expense Account</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('expenseAccountPage', e)} checked={settings.expenseAccountPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Expense Supplier</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('expenseSupplierPage', e)} checked={settings.expenseSupplierPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Expense Invoice</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('expenseInvoicePage', e)} checked={settings.expenseInvoicePage} />
              </Form.Group>

            </Form>

            {/* stockTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Stock</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Stock Control</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('stockControlPage', e)} checked={settings.stockControlPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Stock Transfer</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('stockTransferPage', e)} checked={settings.stockTransferPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Stock Count</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('stockCountPage', e)} checked={settings.stockCountPage} />
              </Form.Group>

            </Form>

            {/* inventoryTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Inventory</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Products</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('productsPage', e)} checked={settings.productsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Categories</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('categoriesPage', e)} checked={settings.categoriesPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Brands</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('brandsPage', e)} checked={settings.brandsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Seasons</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('seasonsPage', e)} checked={settings.seasonsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Vat Group</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('vatGroupPage', e)} checked={settings.vatGroupPage} />
              </Form.Group>

            </Form>


            {/* reportTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Report</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Financial</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('financialPage', e)} checked={settings.financialPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Operational</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('operationalPage', e)} checked={settings.operationalPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Stock Report</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('stockReportPage', e)} checked={settings.stockReportPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Sessions</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('sessionsPage', e)} checked={settings.sessionsPage} />
              </Form.Group>


            </Form>

            {/* toolTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Tool</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Stock Tools</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('stockToolsPage', e)} checked={settings.stockToolsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Opening Year</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('openingYearPage', e)} checked={settings.openingYearPage} />
              </Form.Group>


              <Form.Group column md={5}>
                <Form.Label column sm={8}>pos Tools</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('posToolsPage', e)} checked={settings.posToolsPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Import</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('importPage', e)} checked={settings.importPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Backup</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('backupPage', e)} checked={settings.backupPage} />
              </Form.Group>


            </Form>

            {/* settingTab Pages */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Setting</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>General</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('generalPage', e)} checked={settings.generalPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>User</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('userPage', e)} checked={settings.userPage} />
              </Form.Group>


              <Form.Group column md={5}>
                <Form.Label column sm={8}>Role</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('rolePage', e)} checked={settings.rolePage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Link Account</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('linkAccountPage', e)} checked={settings.linkAccountPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Currency</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('currencyPage', e)} checked={settings.currencyPage} />
              </Form.Group>


            </Form>

            {/* retail tab */}


            <Form style={{ width: '25%' }}>

              <h4 style={{ textAlign: 'left' }}>Retail</h4>
              <div style={{ borderTop: '1px solid #cccccc', margin: '10px 0', marginTop: '4%', marginBottom: '15%' }}></div>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>POS</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('posPage', e)} checked={settings.posPage} />
              </Form.Group>

              <Form.Group column md={5}>
                <Form.Label column sm={8}>Dine In</Form.Label>
                <Switch defaultChecked onChange={(e) => handleChange('dineInPage', e)} checked={settings.dineInPage} />
              </Form.Group>

            </Form>

          </div>

        </div>

        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={toggleModal}>
            Close
          </button>

          <button type="button" className="btn btn-primary" onClick={handleSubmit}>
            Save Data
          </button>

          {loadingEffect && (
            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          )}
        </div>
      </Modal.Body>
    </Modal>
  )
}


export default PagesPermission;